import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  message?: string;
  fullScreen?: boolean;
  className?: string; 
  inline?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = "md", 
  message = "Loading...",
  fullScreen = false,
  className = "",
  inline = false 
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  const containerClasses = fullScreen 
    ? "fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
    : inline
      ? `inline-flex items-center ${className}`
    : `flex items-center justify-center p-8 ${className}`;

    return inline ? (
  <span className={`inline-flex items-center ${className}`}>
    <Loader2 className={`${sizeClasses[size]} animate-spin text-white`} />
    {message && <span className="ml-2 text-sm">{message}</span>}
  </span>
) : (
  <div className={containerClasses}>
    <div className="flex flex-col items-center gap-3">
      <Loader2 className={`${sizeClasses[size]} animate-spin text-harvey-red`} />
      {message && (
        <p className="text-sm text-gray-600 font-medium">{message}</p>
      )}
    </div>
  </div>
);

 };
